(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["merrymood-cart"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('merrymood-cart')) {
  customElements.define('merrymood-cart', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;

      this.ready = true;
      this.busy = false;
      this.blocked = false;

      this.addEventListener('click', e => {
        const snowButton = e.target.closest('[data-snow]');

        if (snowButton) {
          this.classList.toggle('mmc-paused');

          snowButton.textContent = this.classList.contains('mmc-paused')
            ? 'Schnee aktivieren'
            : 'Schnee pausieren';

          return;
        }

        const button = e.target.closest('[data-step],[data-remove]');

        if (!button || this.busy || this.blocked) return;

        const row = button.closest('[data-key]');
        let quantity = 0;

        if (button.hasAttribute('data-step')) {
          const input = row.querySelector('[data-quantity]');
          const min = Number(input.min || 1);
          const step = Number(input.step || 1);

          quantity =
            Number(input.value) +
            Number(button.dataset.step) * step;

          if (quantity < min) quantity = 0;

          if (input.max && quantity > Number(input.max)) {
            this.say(
              'Du hast die maximale Menge für diesen Artikel erreicht.'
            );
            return;
          }
        }

        this.change(row.dataset.key, quantity);
      });

      this.addEventListener('change', e => {
        if (
          !e.target.matches('[data-quantity]') ||
          this.busy ||
          this.blocked
        ) return;

        const input = e.target;
        const quantity = Number(input.value);

        if (
          !input.value ||
          !Number.isInteger(quantity) ||
          quantity < 0 ||
          (quantity > 0 && !input.checkValidity())
        ) {
          this.say('Bitte gib eine gültige Menge ein.');
          this.refresh().catch(() => this.failClosed());
          return;
        }

        this.change(
          input.closest('[data-key]').dataset.key,
          quantity
        );
      });

      this.addEventListener('submit', e => {
        if (!e.target.matches('[data-checkout-form]')) return;

        if (this.busy || this.blocked) {
          e.preventDefault();

          this.say(
            this.blocked
              ? 'Lade die Seite neu, um den Warenkorb zu prüfen.'
              : 'Bitte warte, bis die Aktualisierung abgeschlossen ist.'
          );
        }
      });

      if (!matchMedia('(prefers-reduced-motion: reduce)').matches) {
        const snow = this.querySelector('.mmc-snow');

        for (let i = 0; i < 22; i++) {
          const flake = document.createElement('span');

          flake.textContent = i % 4 ? '•' : '❄';

          flake.style.cssText =
            'left:' + (i * 47.3 % 100) + '%;' +
            'font-size:' + (9 + i % 10) + 'px;' +
            'animation-duration:' + (15 + i % 12) + 's;' +
            'animation-delay:-' + i + 's';

          snow.append(flake);
        }

        this.observer = new ResizeObserver(() => {
          this.style.setProperty(
            '--mmc-fall',
            (this.offsetHeight + 70) + 'px'
          );
        });

        this.observer.observe(this);
      }
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }

    say(message) {
      this.querySelector('.mmc-status').textContent = message;
    }

    lock(value) {
      this.busy = value;
      this.setAttribute('aria-busy', String(value));

      this.querySelectorAll(
        '.mmc-content button,.mmc-content input'
      ).forEach(el => {
        el.disabled = value || this.blocked;
      });
    }

    async api(path, body) {
      const response = await fetch(this.dataset.root + path, {
        method: body ? 'POST' : 'GET',
        headers: {
          'Accept': 'application/json',
          ...(body ? { 'Content-Type': 'application/json' } : {})
        },
        cache: 'no-store',
        ...(body ? { body: JSON.stringify(body) } : {})
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(
          typeof data.description === 'string'
            ? data.description
            : 'Der Warenkorb konnte nicht aktualisiert werden. Bitte versuche es erneut.'
        );
      }

      return data;
    }

    async syncGifts() {
      let cart = await this.api('cart.js');

      const giftKeys = cart.items.filter(x =>
        x.properties &&
        x.properties._merrymood_pack &&
        x.final_price === 0
      ).map(x => x.key);

      const assigned = new Set();

      for (const key of giftKeys) {
        const gift = cart.items.find(x => x.key === key);
        if (!gift) continue;

        const parent = String(gift.properties._merrymood_pack);

        const wanted = assigned.has(parent)
          ? 0
          : cart.items.filter(x =>
              String(x.variant_id) === parent &&
              !(x.properties && x.properties._merrymood_pack)
            ).reduce((sum, x) => sum + x.quantity, 0);

        assigned.add(parent);

        if (gift.quantity !== wanted) {
          cart = await this.api('cart/change.js', {
            id: gift.key,
            quantity: wanted
          });
        }
      }

      return cart;
    }

    async refresh() {
      let content = null;

      const parse = html => {
        if (typeof html !== 'string') return null;

        const doc = new DOMParser().parseFromString(
          html,
          'text/html'
        );

        const roots = Array.from(
          doc.querySelectorAll('merrymood-cart')
        );

        const root = roots.find(el =>
          el.dataset.section === this.dataset.section
        );

        return root
          ? root.querySelector('.mmc-content')
          : null;
      };

      try {
        const url = new URL(
          this.dataset.cart,
          location.origin
        );

        url.searchParams.set(
          'sections',
          this.dataset.section
        );

        const response = await fetch(url.toString(), {
          cache: 'no-store',
          credentials: 'same-origin',
          headers: {
            'Accept': 'application/json'
          }
        });

        if (response.ok) {
          const sections = await response.json();
          content = parse(sections[this.dataset.section]);
        }
      } catch (error) {}

      if (!content) {
        const response = await fetch(
          new URL(this.dataset.cart, location.origin).toString(),
          {
            cache: 'no-store',
            credentials: 'same-origin',
            headers: {
              'Accept': 'text/html'
            }
          }
        );

        if (!response.ok) {
          throw new Error('Die Übersicht konnte nicht aktualisiert werden.');
        }

        content = parse(await response.text());
      }

      if (!content) {
        throw new Error('Übersicht nicht verfügbar.');
      }

      this.querySelector('.mmc-content').replaceWith(content);
      this.lock(this.busy);
    }

    async change(key, quantity) {
      this.lock(true);
      this.say('Warenkorb wird aktualisiert…');

      try {
        await this.api('cart/change.js', {
          id: key,
          quantity: quantity
        });

        await this.syncGifts();
        await this.refresh();

        this.lock(false);
        this.say('Warenkorb und Gesamtbetrag aktualisiert.');
      } catch (error) {
        await this.recover(error);
      }
    }

    async recover(error) {
      try {
        await this.refresh();
        this.lock(false);
        this.say(error.message || 'Bitte versuche es gleich noch einmal.');
      } catch (_) {
        this.failClosed();
      }
    }

    failClosed() {
      this.blocked = true;
      this.lock(false);

      this.say(
        'Verbindung unterbrochen: Lade die Seite neu, um den ' +
        'Gesamtbetrag vor dem Fortfahren zu prüfen.'
      );
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
